import { AiChat, type AiChatMessage, AiPromptTemplate } from 'src/@types/ai';
import { axios } from 'src/utils/axios';

export const fetchMessages = (conversationId: string) =>
  axios
    .get<AiChat>(`/ai/chat/messages`, {
      params: {
        chatRef: conversationId,
      },
    })
    .then(({ data }) => ({
      ...data,
      messages: data.messages.map<AiChatMessage>((i) => ({
        ...i,
        id: i._id,
      })),
    }));

export const answerAudio = async (
  channelId: string,
  file: File,
  image?: File,
) => {
  const fd = new FormData();
  fd.append('file', file);
  if (image) fd.append('image', image);

  await axios.post(`/ai/answer-audio/${channelId}`, fd);
};

export const stopAnswerAudio = async (channelId: string) => {
  await axios.post(`/ai/answer-audio/stop/${channelId}`);
};

export const aiTranscription = async (audio: File) => {
  const fd = new FormData();
  fd.append('audio', audio);

  const { data } = await axios.post('/ai/audio/transcribe', fd);
  return data;
};

export const fetchConversations = async () => {
  const { data } = await axios.get<AiChat[]>('/ai/chats');
  return data;
};

export const createConversation = async () => {
  const { data } = await axios.post<AiChat>('/ai/chat');
  return data;
};

export type UpdateAiConversationPayload = {
  conversationId: string;
  title: string;
};

export const updateConversation = async ({
  conversationId,
  title,
}: UpdateAiConversationPayload) => {
  const { data } = await axios.put<AiChat>('/ai/chat', {
    chatRef: conversationId,
    title,
  });
  return data;
};

export const deleteConversation = async (conversationId: string) => {
  const { data } = await axios.delete<AiChat>('/ai/chat', {
    params: {
      chatRef: conversationId,
    },
  });
  return data;
};

export type PromptPayload = {
  template: AiPromptTemplate;
  context?: string;
  input?: string;
};

export const prompt = async (payload: PromptPayload) => {
  const { data } = await axios.post<{ response: string }>(
    '/ai/prompt',
    payload,
  );
  return data;
};

export * as AIRequests from './ai';
